import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { FlatList, ListRenderItem, StyleSheet, View } from 'react-native';
import { Overlay, OverlayProps } from 'react-native-elements';
import { color, spacing } from '../../theme';
import { Button } from '../Button/Button';
import { Text } from '../Text/Text';

export interface SelectorModalProps<T> extends OverlayProps {
  itemKey?: string;
  items?: T[];
  renderItem: ListRenderItem<T>;
  title?: string;

  onRequestClose?: () => any;
}

function SelectorModal<T>(props: SelectorModalProps<T>) {
  const {
    items,
    renderItem,
    title,
    onRequestClose,
    overlayStyle,
    ...overlayProps
  } = props;

  return (
    <Overlay
      onRequestClose={onRequestClose}
      onDismiss={onRequestClose}
      onBackdropPress={onRequestClose}
      overlayStyle={[styles.container, overlayStyle]}
      {...overlayProps}
    >
      <View style={styles.header}>
        <Text preset="h3">{title}</Text>
        <Button preset="tertiary" onPress={onRequestClose}>
          <FontAwesomeIcon size={20} icon="times" color={color.primary} />
        </Button>
      </View>

      <FlatList data={items} renderItem={renderItem} />
    </Overlay>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 464,
    maxWidth: '95%',
    padding: spacing[4],
    backgroundColor: color.background,
    borderRadius: spacing[4],
    marginBottom: spacing[8],
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: spacing[5],
    maxHeight: '60%',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default SelectorModal;
